/* eslint-disable no-console */
import store from "../store";

export interface ILogger {
  isLogEnabled: boolean;
  message(text: any): void;
  error(text: any, infos: any): void;
}

export default class Logger implements ILogger {
  IS_PROD: boolean = process.env.NODE_ENV === "production";
  APPINSIGHTS_DISABLE: boolean = process.env.VUE_APP_APPINSIGHTS_DISABLE === "true";

  formatMessage(text: any): string {
    return `[${new Date().toLocaleString()}] ${this.stringifyIfObect(text)}`;
  }

  stringifyIfObect(text: any): string {
    if (!text) return "";
    return typeof text === "object" ? JSON.stringify(text) : `${text}`;
  }

  message(text: any): void {
    if (!this.IS_PROD || this.APPINSIGHTS_DISABLE) {
      console.log(this.formatMessage(text));
    }
  }

  shouldTrackAppInsights(): boolean {
    return this.IS_PROD && !this.APPINSIGHTS_DISABLE && !!globalThis.window.$appInsights;
  }

  getSaudeLogProperties(message: string): Record<string, unknown> {
    const hydrated = store?.state?.saude?.hydrated ?? false;
    return {
      hydrated,
      vinculo: hydrated ? store?.state?.saude?.vinculo ?? "" : "",
      operacao: hydrated ? store?.state?.saude?.operacao ?? 0 : 0,
      perfil: hydrated ? store?.state?.saude?.perfil ?? 0 : 0,
      grupo: hydrated ? store?.state?.saude?.grupo ?? 0 : 0,
      message
    };
  }

  trackAppInsightsException(message: string, infos: any): void {
    globalThis.window.$appInsights.trackException({
      exception: infos,
      properties: this.getSaudeLogProperties(message)
    });
    globalThis.window.$appInsights.flush();
  }

  error(text: any, infos: any): void {
    const message = this.formatMessage(text);
    if (this.shouldTrackAppInsights()) {
      try {
        this.trackAppInsightsException(message, infos);
      } catch (err) {
        console.error(message, infos);
        console.error("AIns error", err);
      }
    } else {
      console.error(message, infos);
    }
  }

  get isLogEnabled(): boolean {
    // use se for preciso  contatenar strings
    // if (isLogEnabled()) log(`Uma contatenação de string{$semTerLogDisponivel} é processamento desnecessário);
    return !this.IS_PROD;
  }
}
